import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import "regenerator-runtime/runtime.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import Axios from 'axios';
import { getModule, Vue } from 'nuxt-property-decorator';
import AppModule from '~/store/AppModule';
export var BaseService = /*#__PURE__*/function (_Vue) {
  _inherits(BaseService, _Vue);
  var _super = _createSuper(BaseService);
  function BaseService() {
    _classCallCheck(this, BaseService);
    return _super.apply(this, arguments);
  }
  _createClass(BaseService, null, [{
    key: "getApiCallWithParam",
    value: function () {
      var _getApiCallWithParam = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(urlPath, parameter) {
        var cdpAxios, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              cdpAxios = Axios.create({
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: 'Bearer ' + localStorage.getItem('token')
                }
              });
              _context.next = 3;
              return cdpAxios.get(urlPath, {
                params: parameter
              }).then(function (resp) {
                return resp;
              }).catch(function (error) {
                BaseService.HandleError(error);
              });
            case 3:
              response = _context.sent;
              return _context.abrupt("return", response);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getApiCallWithParam(_x, _x2) {
        return _getApiCallWithParam.apply(this, arguments);
      }
      return getApiCallWithParam;
    }()
  }, {
    key: "getApiCall",
    value: function () {
      var _getApiCall = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(urlPath) {
        var cdpAxios, response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              cdpAxios = Axios.create({
                headers: {
                  'Content-Type': 'application/json'
                }
              });
              _context2.next = 3;
              return cdpAxios.get(urlPath).then(function (resp) {
                return resp;
              }).catch(function (error) {
                BaseService.HandleError(error);
              });
            case 3:
              response = _context2.sent;
              return _context2.abrupt("return", response);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function getApiCall(_x3) {
        return _getApiCall.apply(this, arguments);
      }
      return getApiCall;
    }()
  }, {
    key: "FilePostDownload",
    value: function () {
      var _FilePostDownload = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(urlPath, object) {
        var cdpAxios, response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              cdpAxios = Axios.create({
                responseType: 'blob',
                headers: {
                  Authorization: 'Bearer ' + localStorage.getItem('token'),
                  'Content-Type': 'application/json'
                }
              });
              _context3.next = 3;
              return cdpAxios.post(urlPath, object).then(function (resp) {
                return resp;
              }).catch(function (error) {
                BaseService.HandleError(error);
                throw error;
              });
            case 3:
              response = _context3.sent;
              return _context3.abrupt("return", response);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function FilePostDownload(_x4, _x5) {
        return _FilePostDownload.apply(this, arguments);
      }
      return FilePostDownload;
    }()
  }, {
    key: "postApiCall",
    value: function () {
      var _postApiCall = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(urlPath, object) {
        var cdpAxios, response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              cdpAxios = Axios.create({
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: 'Bearer ' + localStorage.getItem('token')
                }
              });
              _context4.next = 3;
              return cdpAxios.post(urlPath, object).then(function (resp) {
                return resp;
              }).catch(function (error) {
                BaseService.HandleError(error);
                throw error;
              });
            case 3:
              response = _context4.sent;
              return _context4.abrupt("return", response);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function postApiCall(_x6, _x7) {
        return _postApiCall.apply(this, arguments);
      }
      return postApiCall;
    }()
  }, {
    key: "postApiCallWithParam",
    value: function () {
      var _postApiCallWithParam = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(urlPath, object, parameter) {
        var cdpAxios, response;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              cdpAxios = Axios.create({
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: 'Bearer ' + localStorage.getItem('token')
                }
              });
              _context5.next = 3;
              return cdpAxios.post(urlPath, object, {
                params: parameter
              }).then(function (resp) {
                return resp;
              }).catch(function (error) {
                BaseService.HandleError(error);
              });
            case 3:
              response = _context5.sent;
              return _context5.abrupt("return", response);
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function postApiCallWithParam(_x8, _x9, _x10) {
        return _postApiCallWithParam.apply(this, arguments);
      }
      return postApiCallWithParam;
    }()
  }, {
    key: "deleteApiCall",
    value: function () {
      var _deleteApiCall = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(urlPath, parameter) {
        var cdpAxios, response;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              cdpAxios = Axios.create({
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: 'Bearer ' + localStorage.getItem('token')
                }
              });
              _context6.next = 3;
              return cdpAxios.delete(urlPath, {
                params: parameter
              }).then(function (resp) {
                return resp;
              }).catch(function (error) {
                BaseService.HandleError(error);
              });
            case 3:
              response = _context6.sent;
              return _context6.abrupt("return", response);
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      function deleteApiCall(_x11, _x12) {
        return _deleteApiCall.apply(this, arguments);
      }
      return deleteApiCall;
    }()
  }, {
    key: "HandleError",
    value: function HandleError(error) {
      var _a, _b;
      var store = getModule(AppModule);
      // Get error stuff
      var statusCode = error.response ? error.response.status : null;
      var message = error.response ? (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message : null;
      if (message === null || message === undefined) {
        //message = 'Het is niet gelukt om de aanvraag te versturen, probeer het later nog eens.'
        message = 'onbekende fout opgetreden, probeer het later nog eens.';
      }
      // Add error stuff to store
      store.setStateToError(message);
      // Custom error handling when 401
      if (statusCode === 401) {
        // store.logout()
        // window.location.pathname = '/auth/login'
      }
    }
  }]);
  return BaseService;
}(Vue);